import { Action } from '@ngrx/store';
import { CustomerInfoTO } from 'app/core/store/customer-info/customer-info.interface';
import { AdminRoles, Customer } from 'app/core/store/session/user-context/user-context.interface';
import { Definitions } from '../definitions/definitions.interface';

export const CUSTOMER_INFO = 'customer-info:CUSTOMER_INFO';
export const CUSTOMER_INFO_RESET = 'customer-info:CUSTOMER_INFO_RESET';
export const CUSTOMER_INFO_LOAD = 'customer-info:CUSTOMER_INFO_LOAD';
export const CUSTOMER_INFO_LOAD_FAIL = 'customer-info:CUSTOMER_INFO_LOAD_FAIL';
export const CUSTOMER_INFO_LOAD_SUCCESS = 'customer-info:CUSTOMER_INFO_LOAD_SUCCESS';

export class CustomerInfoLoadAction implements Action {
  readonly type = CUSTOMER_INFO_LOAD;
  logPayload = true;

  ui = {
    id: CUSTOMER_INFO,
    busy: true,
  };

  constructor(readonly payload: { customer: Customer }) {}
}

export class CustomerInfoResetAction implements Action {
  readonly type = CUSTOMER_INFO_RESET;
}

export class CustomerInfoLoadFailAction implements Action {
  readonly type = CUSTOMER_INFO_LOAD_FAIL;
  logPayload = true;

  ui = {
    id: CUSTOMER_INFO,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class CustomerInfoLoadSuccessAction implements Action {
  readonly type = CUSTOMER_INFO_LOAD_SUCCESS;
  logPayload = ['customer', 'customerInfo', 'isAgent', 'isAdmin', 'isEpsUser', 'canRelocate', 'useEmailActors', 'isSuperUser', 'adminRoles'];

  ui = {
    id: CUSTOMER_INFO,
    busy: false,
  };

  constructor(
    readonly payload: {
      customer: Customer;
      customerInfo: CustomerInfoTO;
      isAdmin: boolean;
      isAgent: boolean;
      isEpsUser: boolean;
      canRelocate: boolean;
      useEmailActors: boolean;
      canAccessHomeMarketBonus: boolean;
      isSuperUser: boolean;
      adminRoles: AdminRoles;
      definitions: Definitions;
    }
  ) {}
}

export type Actions = CustomerInfoResetAction | CustomerInfoLoadAction | CustomerInfoLoadFailAction | CustomerInfoLoadSuccessAction;
